import React, { FC } from 'react';
// eslint-disable-next-line import/no-unresolved
import { NewsItemProps } from './types';
import locationSVG from '../../../../icons/location.svg';
import viewsSVG from '../../../../icons/views.svg';
import dateSVG from '../../../../icons/date.svg';
// @ts-ignore
import { FormattedDate, Icon } from '@plone/volto/components';
// @ts-ignore
import { Link } from 'react-router-dom';

const HeadNews: FC<NewsItemProps> = ({
  id,
  title,
  visited_users,
  description,
  image,
  created,
  readed,
  review_state,
  location,
  onMouseEnter,
}) => {
  return (
    <Link
      to={id}
      className={`big-news ${readed ? 'readed' : 'not-readed'}`}
      aria-label={title}
      onMouseEnter={onMouseEnter}
    >
      <div className={'left-column'}>
        <div className={'badge'}>SCHLAGZEILE</div>
        <p
          className={`title ${review_state === 'private' ? 'private' : 'not-private'}`}
        >
          {title}
        </p>
        <p className={`description`}>{description}</p>
        <div className={'additional-data'}>
          <div className={`date`}>
            <Icon className={'icon'} name={dateSVG} size={'1.25rem'} />
            <FormattedDate
              date={created}
              format={{ year: 'numeric', month: 'short', day: 'numeric' }}
              long={false}
              includeTime={false}
              relative={false}
              className=""
              locale={false}
              children={false}
            />
          </div>
          <div className={`views`}>
            <Icon className={'icon'} name={viewsSVG} size={'1.25rem'} />
            <p className={'value'}> {visited_users.length} </p>
          </div>
          <div className={'location'}>
            <Icon className={'icon'} name={locationSVG} size={'1.25rem'} />
            <div className={'value'}>
              {location.map((location, idx) => (
                <p key={idx} className={'entry'}>
                  {location.title}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={'right-column'}>
        {image ? (
          // only decoration, the link already carries the title (#22806)
          <img src={`${id}/@@images/image/preview`} alt="" />
        ) : (
          <></>
        )}
      </div>
    </Link>
  );
};

export default HeadNews;
